import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../../Utilities/DataLayer';
import Formatter from '../../Utilities/Formatter';

class WatchListCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flipped: false,
            extendedData: []
        }
        this.handleFlipping = this.handleFlipping.bind(this);
        this.removeFromWatch = this.removeFromWatch.bind(this);
        this.formatter = new Formatter();
    }

    removeFromWatch = (sfId) => {
        var dl = new DataLayer();
        dl.Get('/common/removefromwatch?sfId=' + sfId, 200).then((response) => {
            this.props.removeFromList();
            //const { history } = this.props;
            //history.push({
            //    pathname: '/salesforce/watchlist',
            //})
        })
    }

    async handleFlipping() {
        if (!this.state.flipped) {
            this.props.loaderOn();
            var dl = new DataLayer();
            let url = '/common/getdemonstratorstats?demId=' + this.props.sfId + '&unitId=' + this.props.unitId;
            if (this.props.statusCode1 != 'D') {
                url = '/common/getunitstats?demId=' + this.props.sfId + '&unitId=' + this.props.unitId
            }
            await dl.Get(url, 200).then((response) => {
                var tttt = "";
                this.setState({
                    extendedData: response.data,
                    flipped: !this.state.flipped
                })
                this.props.loaderOff();
            })
        } else {
            this.setState({
                flipped: !this.state.flipped
            })
        }
    }

    render() {
        return (
            <div>
                {!this.state.flipped ? (
                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{this.props.unitName.toUpperCase()}</MDBCardTitle>
                        <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.demName.toUpperCase()}</MDBCardTitle>
                        <hr />
                        <MDBCardText>
                            <MDBIcon icon="phone" />&nbsp;{this.props.telephoneCell}<br />
                            <MDBIcon far icon="id-card" />&nbsp;{this.props.sfCurrentCode}<br />
                            <MDBIcon icon="sitemap" />&nbsp;{this.props.status}
                        </MDBCardText>
                        <hr />
                        <div className="flex-row text-center" >
                            <MDBBtn tag="a" color="purple" floating onClick={() => this.removeFromWatch(this.props.sfId)}>
                                <MDBIcon icon="trash-alt" />
                            </MDBBtn>
                            <MDBBtn tag="a" color="pink" floating onClick={this.handleFlipping}>
                                <MDBIcon icon="info" />
                            </MDBBtn>
                        </div>
                    </MDBCard>
                ) : (
                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                            {/*<MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>Start Week: {this.state.extendedData[0].startWeekId}</MDBCardTitle>*/}

                            {this.props.statusCode1 == "D" ? (
                                <div>
                                    <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>Dem Detail: {this.state.extendedData[0].name}</MDBCardTitle>
                                    <hr />
                                    <MDBCardText>
                                        <MDBRow>
                                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                                <span style={{ fontSize: "14px" }}>Sales This Seg</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData[0].sales)}</strong>
                                            </MDBCol>
                                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                <span style={{ fontSize: "14px" }}>Total Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData[0].totalSales)}</strong>
                                            </MDBCol>
                                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                <span style={{ fontSize: "14px" }}>Recruits This Seg</span><br /> <strong>{this.state.extendedData[0].recruits}</strong>
                                            </MDBCol>
                                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                <span style={{ fontSize: "14px" }}>Total Recruits</span><br /> <strong>{this.state.extendedData[0].totalRecruits}</strong>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCardText>
                                </div>
                            ) :
                                (
                                    <div>
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>Unit Detail: {this.state.extendedData.managerName}</MDBCardTitle>
                                        <hr />
                                        <MDBCardText>
                                            <MDBRow>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                                    <span style={{ fontSize: "14px" }}>Personal Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.personalSales)}</strong>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                    <span style={{ fontSize: "14px" }}>Unit Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.unitSales)}</strong>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                    <span style={{ fontSize: "14px" }}>Promoteout Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.promoteOutSales)}</strong>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                    <span style={{ fontSize: "14px" }}>Total Unit Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.totalUnitSales)}</strong>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                    <span style={{ fontSize: "14px" }}>New Recruits</span><br /> <strong>{this.state.extendedData.newRecruits}</strong>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                    <span style={{ fontSize: "14px" }}>Qualified Recruits</span><br /> <strong>{this.state.extendedData.qualifiedRecsInSeg}</strong>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBCardText>
                                    </div>
                                )}

                            <hr />
                            <div className="flex-row text-center" >
                                <MDBBtn tag="a" color="grey" floating onClick={this.handleFlipping}>
                                    <MDBIcon icon="undo-alt" />
                                </MDBBtn>
                            </div>
                        </MDBCard>
                    )}
            </div>
        )
    }
}

export default WatchListCard;